<template>
  <div class="card">
    <el-card class="view-card">
      <div slot="header" class="view-card-title">
        <div class="view-card-title-left">
          <span>
            <em v-if="textItem.is_must == '1'" style="color: red;margin-right: 5px">*</em>{{textIndex+1}}.{{textItem.type | getExamStyleCn}}
          </span>
        </div>
        <div class="view-card-title-right">
          <el-tooltip effect="dark" content="必填" placement="top">
            <el-checkbox class="cy_btn_i" v-model="textItem.is_must" true-label="1" false-label="0"></el-checkbox>
          </el-tooltip>
          <el-tooltip class="mover view-card-title-right-img" style="display: inline-block" effect="dark" content="按住拖动选项" placement="top">
            <div>
              <img class="cy_btn_i draggable_item colourless" src="@/assets/answerExam/drag0.svg" alt="" >
              <img class="cy_btn_i draggable_item color" src="@/assets/answerExam/drag1.svg" alt="" >
            </div>
          </el-tooltip>
          <el-tooltip class="view-card-title-right-del" style="display: inline-block" effect="dark" content="删除题目" placement="top">
            <i class="cy_btn_i el-icon-delete" @click="handleDelTest(textIndex)"></i>
          </el-tooltip>
        </div>
      </div>
      <div class="view-card-content">
        <div class="view-card-content-textName">
          <el-input type="text" v-model="textItem.case_problem" :placeholder="textItem.placeholder"></el-input>
        </div>
        <div class="view-card-content-select"></div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    textArray:{
      type:Array,
      default:function() {
        return []
      }
    },
    textItem:{
      type:Object,
      default:function() {
        return {}
      }
    },
    textIndex:{
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    handleDelTest:function(textIndex){
      this.$confirm('此操作将永久删除该题目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.textArray.splice(textIndex,1);
        setTimeout(() => {
          this.$message.success('删除成功!');
        }, 200);
      }).catch(() => {
        setTimeout(() => {
          this.$message.info('已取消删除!');
        }, 200);
      });
    },
    changeAbc:function (index) {
      return String.fromCharCode(index+65)
    }
  },
  computed:{

  },
  filters:{
    getExamStyleCn:function (val) {
      if(val == "ZGT_WDT"){
        return "问答题";
      }
    }
  }
};
</script>

<style lang='scss' scoped>
  ::v-deep .el-input__inner{
    height: 30px !important;
    &:hover{
      border: 1px dashed #DCDFE6;
    }
    border: 0px dashed #DCDFE6;
    &:focus-within{
      background-color: #f4f4f4;
    }
  }
  ::v-deep input::-webkit-input-placeholder {
    text-align: left;
    color: #555A64;
  }
  ::v-deep .el-card__body{
    padding: 0px 0px 0px 0px;
  }
  ::v-deep .el-checkbox__inner{
    border: 1px solid #afb0b2;
  }
  .cy_btn_i {
    margin-left: 10px;
    color: #afb0b2;
    font-size: 20px;
    cursor: pointer;
    vertical-align: middle;
  }
  .cy_btn_i:hover {
    color: #1e80ff;
  }


  .view-card{
    margin-top: 20px;
    border-radius: 3px;
    ::v-deep .el-card__header{
      height: 50px !important;
      padding: 0px 0px 0px 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #FAFBFC;
      .view-card-title{
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .view-card-title-left{
          span{
            margin-left: 20px;
            font-size: 16px;
            font-weight: 400;
            color: #555A64;
          }
        }
        .view-card-title-right{
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          .view-card-title-right-img{
            &:hover{
              .color{
                display: inline-block;
              }
              .colourless{
                display: none;
              }
            }
            .color{
              display: none;
            }
          }
          .view-card-title-right-del{
            margin-right: 10px;
          }
        }
      }

    }
    .view-card-content{
      display: flex;
      flex-flow: column nowrap;
      padding: 10px 0px 0px 20px;
      .view-card-content-textName{
        width: 520px;
        line-height: 1.43;
        text-align: left;
        font-size: 16px;
        margin-bottom: 10px;
      }
      .view-card-content-select{
        width: 520px;
        height: 36px;
        background: #FFFFFF;
        border: 1px solid #D1D1D1;
        border-radius: 3px;
        margin-bottom: 10px;
      }
      /*.view-card-content-select{*/
        /*display: flex;*/
        /*flex-flow: column nowrap;*/
        /*width: 520px;*/
        /*.view-card-content-select-item{*/
          /*display: flex;*/
          /*align-items: center;*/
          /*margin-bottom: 10px;*/
          /*&:hover{*/
            /*.colourless{*/
              /*display: inline-block;*/
            /*}*/
          /*}*/
          /*.color{*/
            /*display: none;*/
          /*}*/
          /*.colourless{*/
            /*display: none;*/
          /*}*/
          /*.select-item-move{*/
            /*&:hover{*/
              /*.color{*/
                /*display: inline-block;*/
              /*}*/
              /*.colourless{*/
                /*display: none;*/
              /*}*/
            /*}*/
            /*width: 16px;*/
            /*height: 16px;*/
            /*cursor: pointer;*/
            /*img{*/
              /*width: 16px;*/
              /*height: 16px;*/
            /*}*/
            /*margin-right: 5px;*/
          /*}*/
          /*.select-item-radio{*/
            /*height: 16px;*/
            /*margin-right: 5px;*/
            /*font-size: 16px;*/
            /*color: #555A64;*/
          /*}*/
        /*}*/
      /*}*/
    }
  }

</style>
